import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_CASHIER_SHIFT = "SET_CASHIER_SHIFT";
export const SET_CASHIER_SHIFTS = "SET_CASHIER_SHIFTS";
export const SET_CASHIER_SHIFT_LOADING = "SET_CASHIER_SHIFT_LOADING";
export const SET_CASHIER_SHIFT_ERROR = "SET_CASHIER_SHIFT_ERROR";

export const fetchCurrentCashierShift = () => {
  return async (dispatch) => {
    dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/cashier-shifts/current");
      dispatch({ type: SET_CASHIER_SHIFT, data: response?.data?.data || null });
      return response?.data?.data || null;
    } catch (error) {
      dispatch({
        type: SET_CASHIER_SHIFT_ERROR,
        error: error?.response?.data?.message || "Gagal mengambil shift kasir.",
      });
      return null;
    } finally {
      dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: false });
    }
  };
};

export const openCashierShift = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post("/cashier-shifts/open", data), {
        loading: "Membuka shift kasir...",
        success: "Shift kasir berhasil dibuka!",
        error: (err) => err?.response?.data?.message || "Gagal membuka shift kasir!",
      });
      dispatch({ type: SET_CASHIER_SHIFT, data: response?.data?.data || null });
      return { success: true, data: response?.data?.data || null };
    } catch (error) {
      dispatch({
        type: SET_CASHIER_SHIFT_ERROR,
        error: error?.response?.data?.message || error?.message || "Gagal membuka shift kasir.",
      });
      return { success: false, error };
    } finally {
      dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: false });
    }
  };
};

export const closeCashierShift = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`/cashier-shifts/${id}/close`, data), {
        loading: "Menutup shift kasir...",
        success: "Shift kasir berhasil ditutup!",
        error: (err) => err?.response?.data?.message || "Gagal menutup shift kasir!",
      });
      dispatch({ type: SET_CASHIER_SHIFT, data: null });
      return { success: true, data: response?.data?.data || null };
    } catch (error) {
      dispatch({
        type: SET_CASHIER_SHIFT_ERROR,
        error: error?.response?.data?.message || error?.message || "Gagal menutup shift kasir.",
      });
      return { success: false, error };
    } finally {
      dispatch({ type: SET_CASHIER_SHIFT_LOADING, status: false });
    }
  };
};
